"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../Label"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Menu = _interopRequireDefault(require("../Menu"));

var _constants = require("../constants");

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Button = _interopRequireDefault(require("./Button.style"));

var _dec, _class;

let Button = (_dec = (0, _reactJss.default)(_Button.default), _dec(_class = class Button extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      menu: false
    };
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleClick(e) {
    const {
      children,
      visibility,
      onKeyPress,
      onClick
    } = this.props;
    if (!_utils.default.isVisible(visibility)) return;

    if (children) {
      this.setState({
        menu: true
      });
    }

    if (e.type === 'keypress') {
      onKeyPress(e);
    } else {
      onClick(e);
    }
  }

  handleKeyPress(e) {
    this.handleClick(e);
  }

  handleMenuClose() {
    this.setState({
      menu: false
    });
  }

  renderMenu() {
    const {
      classes,
      children
    } = this.props;
    if (!children) return null;
    const {
      menu
    } = this.state;
    const visibility = menu ? 'visible' : 'hidden';
    return /*#__PURE__*/_react.default.createElement(_Menu.default, {
      className: (0, _clsx.default)(classes.menu),
      visibility: visibility,
      onClose: this.handleMenuClose
    }, children);
  }

  getIconSize(label, size) {
    let iconSize;
    /**
     * In future labels and icons will be passed only as
     * separate nodes and ugly code below can be removed
     */

    if (label) {
      iconSize = size === 'large' ? 'medium' : 'small';
    } else if (size === 'xxsmall') {
      iconSize = 'micro';
    } else {
      iconSize = size === 'small' || size === 'xsmall' ? 'small' : 'medium';
    }

    return iconSize;
  }

  getIconColor() {
    const {
      type
    } = this.props;
    if (![_constants.BUTTON_TYPE.tertiary, _constants.BUTTON_TYPE.quinary].includes(type)) return 'currentColor';
    return '';
  }

  getIcon(icon) {
    if (!icon) return null;
    if ((0, _react.isValidElement)(icon)) return icon;
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: icon,
      size: this.getIconSize(this.props.label, this.props.size),
      color: this.getIconColor()
    });
  }

  render() {
    const _this$props = this.props,
          {
      id,
      classes,
      className,
      type,
      size,
      label,
      icon,
      visibility,
      fullWidth,
      onMouseEnter,
      onMouseLeave,
      rounded,
      fontWeight,
      iconAfter,
      disabled,
      dataTestId
    } = _this$props,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["id", "classes", "className", "type", "size", "label", "icon", "visibility", "fullWidth", "onMouseEnter", "onMouseLeave", "rounded", "fontWeight", "iconAfter", "disabled", "dataTestId"]);
    const btnClasses = (0, _clsx.default)(className, classes.button, classes[type], classes[size], {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled' || disabled
    }, {
      nonInteractive: disabled
    }, {
      fullWidth
    }, {
      hideLabel: (0, _react.isValidElement)(label) ? false : !label || !label.length
    }, {
      hideIcon: !icon
    }, {
      hideIconAfter: !iconAfter
    }, {
      rounded
    });
    const tabIndex = _utils.default.isVisible(visibility) ? 0 : -1;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      ref: el => this.btn = el,
      id: id,
      className: btnClasses,
      onClick: this.handleClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onKeyPress: this.handleKeyPress,
      tabIndex: tabIndex,
      "data-testid": dataTestId
    }, props), this.getIcon(icon), (0, _react.isValidElement)(label) ? label : /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: label,
      fontSize: "medium",
      textColor: "inherit",
      fontWeight: fontWeight
    }), this.getIcon(iconAfter), this.renderMenu());
  }

}) || _class);
Button.TYPE = _constants.BUTTON_TYPE;
Button.SIZE = {
  xxsmall: 'xxsmall',
  xsmall: 'xsmall',
  small: 'small',
  smallplus: 'smallplus',
  medium: 'medium',
  large: 'large'
};
Button.defaultProps = {
  type: Button.TYPE.default,
  size: Button.SIZE.medium,
  visibility: 'visible',
  disabled: false,
  onClick: () => {},
  onKeyPress: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  rounded: false,
  fontWeight: 'semibold'
};
var _default = Button;
exports.default = _default;